import {useState} from 'react'
import {useSearchParams} from 'react-router-dom'
import {PageHeader, TabsComponent, CardComponent} from '@/components/molecules'
import {UploadTemplateWithModal} from '@/components/organisms'
import Inventory from '@/pages/Inventory'
import WarehouseList from '@/containers/ProductsContainer/Fullfillment/WarehouseList/WarehouseList'

/**
 * Fulfillment component that manages warehouse and inventory management interface.
 * Includes card-based navigation and tabbed content display.
 *
 * @returns {JSX.Element} The rendered fulfillment page component.
 */
export const Fullfillment = () => {
  const [params] = useSearchParams()
  const tab = params.get('tab') ? parseInt(params.get('tab')) : 0
  const [openUpload, setOpenUpload] = useState(false)



  /**
   * Card config used at the top of the page
   */
  const cardList = [
    {
      centralIcon: 'local_police',
      ctaPrimary: {
        text: 'Add Template',
        onClick: () => console.log('add template'),
      },
      title: 'Warehouses',
    },
    {
      centralIcon: 'local_police',
      ctaPrimary: {
        text: 'Add Template',
        onClick: () => setOpenUpload(true),
      },
      title: 'Inventory',
    },
  ]



  /**
   * Tab config for toggling between "Warehouses" and "Inventory"
   */
  const tabList = [
    {
      id: 'Warehouses',
      tabLabel: 'Warehouses',
      title: 'Warehouses',
      tabComponent: <WarehouseList />,
    },
    {
      id: 'Inventory',
      tabLabel: 'Inventory',
      title: 'Inventory',
      tabComponent: <Inventory />,
    },
  ]

  return (
    <div className="fullfillmentContainer flex flex-col">
      <PageHeader title="Fullfillment" />
      <div className="targetCardComponent mb-5">
        <CardComponent cardList={cardList} />
      </div>
      <TabsComponent tabList={tabList} defaultTabIndex={tab} />
      <UploadTemplateWithModal openUpload={openUpload} setOpenUpload={setOpenUpload} />

      
    </div>
  )
}
